module.exports = __webpack_public_path__ + "static/media/peach_chickpea_curry.47b1841d.jpg";